import { SmallSubtitle, SmallTitle } from '@sleepstation/components'
import { HLayout, VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import { padding, width } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { formatAuthorCredit } from '../../../../../../helpers/formatting/author'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const AVATAR_ALT = `Author`

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(HLayout).attrs({
  spacing: 0.25,
  align: LAYOUT_ALIGN.TOP,
})`
  ${padding(0.5)}

  > *:first-child {
    width: auto;
    height: auto;
    flex-basis: auto;
    flex-shrink: 1;
  }

  > *:last-child {
    flex-shrink: 0;
  }
`

const IconWrapper = styled.div`
  position: relative;

  /* stylelint-disable-next-line */
  > * {
    ${width(1.75)}
  }
`

const Text = styled(VLayout).attrs({ spacing: LAYOUT_SPACING.SMALL })`
  flex-grow: 2;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Content = ({ title, author }) => {
  const { avatarImage } = author
  const credit = formatAuthorCredit(author)

  return (
    <Layout>
      <Text>
        <SmallTitle shouldPreventWidows={false}>{title}</SmallTitle>
        <SmallSubtitle shouldPreventWidows={false}>{credit}</SmallSubtitle>
      </Text>
      <IconWrapper>
        <img alt={AVATAR_ALT} src={avatarImage.url} />
      </IconWrapper>
    </Layout>
  )
}

Content.propTypes = {
  title: PropTypes.string.isRequired,
  author: PropTypes.object.isRequired,
}

export default Content
